/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.sync.getLatestCommit'

export { $nsid }

/** Get the current commit CID & revision of the specified repo. Does not require auth. */
const main = l.query(
  $nsid,
  l.params({ did: l.string({ format: 'did' }) }),
  l.jsonPayload({
    cid: l.string({ format: 'cid' }),
    rev: l.string({ format: 'tid' }),
  }),
  ['RepoNotFound', 'RepoTakendown', 'RepoSuspended', 'RepoDeactivated'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
